var map = {
	"./banamex.png": 5235,
	"./banorte.png": 8403,
	"./bbva.png": 771,
	"./clip.png": 4571,
	"./inbursa.png": 5787,
	"./konfio.png": 432,
	"./mercado-pago.png": 8128,
	"./netpay.png": 1590,
	"./santander.png": 375,
	"./scotiabank.png": 1044,
	"./zettle.png": 9770
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1538;